import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { InfluencerContainer } from '~/features/Influencer/InfluencerContainer';
import useShopInfo from '~/hooks/live/useShopInfo';
import cn from 'classnames';
import { useSiteContext } from '~/context/SiteContext';
import { FiShoppingBag } from 'react-icons/fi';
import { useCart } from '~/context/CartContext';
import { parseInt } from 'lodash';
import useQuery from '~/hooks/useQuery';

const InfluencerPage: React.FC = () => {
  const { influencerSlug, streamId } = useParams<{
    influencerSlug: string;
    streamId?: string;
  }>();
  const streamIdAsNumber = streamId ? parseInt(streamId) : undefined;
  const query = useQuery();
  const showRegistrationConfirmation = query.has('registration-success');

  const { name } = useShopInfo();
  const { header } = useSiteContext();
  const logo = header?.logo;
  const { toggleMiniCart, cart } = useCart();
  const history = useHistory();

  // Should never happen due to the routes on the monolith
  if (!influencerSlug) return null;

  const handleSelectReplay = (id: number) => {
    history.push(`/${influencerSlug}/${id}`);
  };

  return (
    <div
      data-testid={'influencerPage'}
      className={'fixed inset-0 z-10 bg-white flex flex-col'}
    >
      <header
        className={'shadow bg-white p-4 flex justify-between flex-0'}
        style={{ height: 57 }}
      >
        {/* For spacing */}
        <div />

        <h1
          className={cn(
            'whitespace-nowrap flex items-center text-h4 md:text-h4-lg text-center',
          )}
        >
          {logo && (
            <figure>
              <img src={logo} alt={name} style={{ height: 49 }} />
            </figure>
          )}
          {!logo && name && <span>{name}</span>}
        </h1>

        <button
          aria-label={'Open cart'}
          onClick={toggleMiniCart}
          className={'flex'}
        >
          <FiShoppingBag size={'1.5rem'} className={'text-gray-400'} />
          {!!cart?.itemCount && (
            <div
              className={
                'text-xs bg-red text-white font-bold rounded-full relative flex items-center justify-center px-1'
              }
              style={{ minHeight: 20, minWidth: 20, top: '-8px', right: '2px' }}
            >
              {cart.itemCount}
            </div>
          )}
        </button>
      </header>

      <main className={'overflow-auto flex-1'}>
        <InfluencerContainer
          slug={influencerSlug}
          onSelectReplay={handleSelectReplay}
          selectedStreamId={streamIdAsNumber}
          showRegistrationConfirmation={showRegistrationConfirmation}
        />
      </main>
    </div>
  );
};

export { InfluencerPage };
